module.exports = __webpack_public_path__ + "media/images/covers/foundation/our-teachers-02-7962d2d49db193759553e83b32bab0c7.jpg";